import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { FinParcoursStore } from '../référentiel-métier-parcours/store/fin-parcours/fin-parcours.store';
import { RéférentielLivrableStore } from '../dashboard/store/référentiel-livrable.store';
import { Référentiel } from '../administration/gestion-référentiels/models/référentiel.model';
import { RéférentielService } from '../administration/gestion-référentiels/référentiel.service';
import { ReferentielStore } from '../administration/gestion-référentiels/store/referentiel.store';

/**
 * Resolver for loading selected referentiel in store by slug.
 * @param route
 */
export const referentielResolver: ResolveFn<Observable<Référentiel> | undefined> = (route) => {
  const referentielService = inject(RéférentielService);
  const referentielStore = inject(ReferentielStore);
  const finParcoursStore = inject(FinParcoursStore);
  const referentielLivrableStore = inject(RéférentielLivrableStore);
  const slug = route.params['slugRef'] as string;

  if (slug === 'admin' || !slug) {
    return undefined;
  }

  const fragments = !!slug ? slug.split('-') : [];
  const idReferentiel = fragments.length ? fragments[0] : '';
  return referentielService.findById(idReferentiel).pipe(
    tap((referentiel) => {
      referentielStore.select(referentiel);
      finParcoursStore.chargerFinsParcours({ fins: referentiel.finsParcours });
      referentielLivrableStore.charger();
    }),
  );
};
